import { render, staticRenderFns } from "./AddressEditForm.vue?vue&type=template&id=26bb42fe"
import script from "./AddressEditForm.vue?vue&type=script&lang=js"
export * from "./AddressEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports